(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/models/board.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/models/board.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const rulesRadio = svs.numbergames.game_model.rulesRadio;
svs.numbergames.game_model.models.Board = svs.numbergames.core.NumbergamesModel.extend({
  defaults() {
    return {
      productId: '',
      numbers: undefined,
      numbersExtra: undefined,
      level: undefined,
      hasKungKeno: undefined,
      isPackage: false,
      isSystem: false,
      isEmpty: true,
      isValid: false,
      numbersIsValid: false,
      numbersExtraIsValid: false,
      isActive: false,
      rowCount: 0,
      price: 0,
      rowPrice: 0
    };
  },
  initialize() {
    this.updateRowCount();
    this.updatePrice();
    this.listenTo(this, 'change:level', this.levelChanged);
    this.listenTo(this, 'number:added number:removed number:changed huxfluxed cleared', this.numberlistsChanged);
    this.listenTo(this, 'change:rowCount change:hasKungKeno', this.updatePrice);
    if (this.get('isSystem')) {
      this.listenTo(this, 'change:board change:level', this.updateRowCount);
    } else {
      this.listenTo(this, 'change:isValid', this.updateRowCount);
    }
    this.get('numbers').on('all', _ref => {
      let {
        event,
        data
      } = _ref;
      return this.trigger(event, this, data);
    });
    if (this.has('numbersExtra')) {
      this.get('numbersExtra').on('all', _ref2 => {
        let {
          event,
          data
        } = _ref2;
        return this.trigger(event, this, _objectSpread(_objectSpread({}, data), {}, {
          isExtra: true
        }));
      });
    }
  },
  numberlistsChanged() {
    if (this.get('isSystem')) {
      this.updateSystemLimits();
    }
    this.setValid();
    this.trigger('change:board');
  },
  updateRowCount() {
    let rowCount = 0;
    if (this.get('isValid')) {
      if (this.get('isSystem')) {
        const {
          numbersMaxLength,
          numbersExtraMaxLength
        } = rulesRadio.request('rules');
        rowCount = svs.numbergames.rules.system.generatedRows({
          numbersLength: this.get('numbers').length,
          numbersExtraLength: this.has('numbersExtra') && this.get('numbersExtra').length,
          numbersRowSize: this.get('level') || numbersMaxLength,
          numbersExtraRowSize: numbersExtraMaxLength
        });
      } else {
        rowCount = 1;
      }
    }
    this.set({
      rowCount
    });
  },
  updatePrice() {
    const rowPriceMulti = 1 + Boolean(this.get('hasKungKeno'));
    const price = this.get('rowCount') * this.get('rowPrice') * rowPriceMulti;
    this.set({
      price
    });
  },
  toggleNumber(_ref3) {
    let {
      number,
      isExtra = false,
      manual = false
    } = _ref3;
    if (this.has('level') && !this.get('level')) {
      const dialog = new svs.ui.dialog.Confirm({
        icon: 'information',
        allowDimmerClick: true,
        branding: svs.ui.dialog.branding.TUR,
        type: svs.ui.dialog.type.INFO,
        title: 'Välj system!',
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: 'Du måste först välja vilket system du vill spela. Det avgör Kenonivå och påverkar vinstplanen. Därefter kan du välja dina nummer. ' + 'Ju fler nummer desto fler rader skapar du på din valda Kenonivå. '
        }],
        actions: [{
          title: 'OK'
        }]
      });
      svs.ui.dialog.api.add(dialog);
    }
    const numberList = this.get(isExtra ? 'numbersExtra' : 'numbers');
    numberList.toggle({
      number,
      manual
    });
  },
  setNumber(_ref4) {
    let {
      number,
      index,
      isExtra = false,
      manual = false
    } = _ref4;
    const numberType = isExtra ? 'numbersExtra' : 'numbers';
    const numberList = this.get(numberType);
    numberList.set({
      index,
      number,
      manual
    });
  },
  addHuxfluxed(_ref5) {
    let {
      number,
      isExtra = false,
      manual = false
    } = _ref5;
    const numberList = this.get(isExtra ? 'numbersExtra' : 'numbers');
    numberList.addHuxfluxed({
      number,
      manual
    });
  },
  canHuxflux() {
    return this.get('numbers').canHuxflux() || this.has('numbersExtra') && this.get('numbersExtra').canHuxflux();
  },
  setValid() {
    const numbersIsValid = this.get('numbers').isValid();
    let isEmpty = this.get('numbers').isEmpty();
    let isValid = numbersIsValid;
    let numbersExtraIsValid;
    if (this.has('numbersExtra')) {
      numbersExtraIsValid = this.get('numbersExtra').isValid();
      isEmpty = isEmpty && this.get('numbersExtra').isEmpty();
      isValid = isValid && numbersExtraIsValid;
    }
    this.set({
      isValid,
      isEmpty,
      numbersExtraIsValid,
      numbersIsValid
    });
  },
  huxflux(numbersLength, numbersExtraLength) {
    if (this.has('numbers')) this.get('numbers').huxflux(numbersLength);
    if (this.has('numbersExtra')) this.get('numbersExtra').huxflux(numbersExtraLength);
    this.trigger('huxfluxed', this);
    svs.numbergames.game_model.logger.debug('Board huxfluxed', this);
  },
  clear() {
    const rules = rulesRadio.request('rules');
    if (this.has('numbers')) this.get('numbers').removeAll();
    if (this.has('numbersExtra')) this.get('numbersExtra').removeAll();
    if (this.has('hasKungKeno')) this.set('hasKungKeno', rules.kungKeno);
    if (this.has('level') && !this.get('isActive')) this.set({
      level: undefined
    });
    this.trigger('cleared', this);
    svs.numbergames.game_model.logger.debug('Board cleared', this);
  },
  getNumberListArrays() {
    return {
      numbers: this.get('numbers').toArray(),
      numbersExtra: this.has('numbersExtra') && this.get('numbersExtra').toArray()
    };
  },
  parse(attrs) {
    const rules = rulesRadio.request('rules');
    let numbersOptions = {};
    let numbersExtraOptions = {};
    if (attrs.isSystem) {
      const {
        numbersLimits,
        numbersExtraLimits
      } = svs.numbergames.rules.system.systemLimits({
        rules,
        numberSize: attrs.numbers && attrs.numbers.length,
        numberExtraSize: attrs.numbersExtra && attrs.numbersExtra.length,
        level: attrs.level
      });
      numbersOptions = {
        minLength: numbersLimits.min,
        maxLength: numbersLimits.max
      };
      if (numbersExtraLimits) {
        numbersExtraOptions = {
          minLength: numbersExtraLimits.min,
          maxLength: numbersExtraLimits.max
        };
      }
    } else if (attrs.isPackage) {
      numbersOptions = {
        maxLength: attrs.level || rules.numbersMaxLength,
        huxfluxManual: true 
      };
      numbersExtraOptions = {
        huxfluxManual: true
      };
    } else {
      const length = attrs.level || rules.numbersMaxLength;
      numbersOptions = {
        maxLength: length,
        minLength: length,
        huxfluxManual: rules.huxfluxManual,
        skipSort: rules.disableSortBoardNumbers || false
      };
      numbersExtraOptions = {
        huxfluxManual: rules.huxfluxManual,
        skipSort: rules.disableSortBoardNumbers || false
      };
    }
    if (rules.numbersMaxValue > 0 && rules.numbersMaxLength > 0) {
      attrs.numbers = new svs.numbergames.game_model.utils.NumberList(_objectSpread({
        numbers: attrs.numbers,
        maxValue: rules.numbersMaxValue
      }, numbersOptions));
    }
    if (rules.numbersExtraMaxValue > 0 && rules.numbersExtraMaxLength > 0) {
      attrs.numbersExtra = new svs.numbergames.game_model.utils.NumberList(_objectSpread({
        numbers: attrs.numbersExtra,
        maxValue: rules.numbersExtraMaxValue,
        maxLength: rules.numbersExtraMaxLength,
        minLength: rules.numbersExtraMaxLength
      }, numbersExtraOptions));
    }
    attrs.rowPrice = rules.rowPrice;
    if (typeof attrs.hasKungKeno !== 'boolean') {
      attrs.hasKungKeno = rules.kungKeno;
    }
    attrs.isEmpty = attrs.numbers && attrs.numbers.isEmpty() && (!attrs.numbersExtra || attrs.numbersExtra.isEmpty());
    attrs.isValid = attrs.numbers && attrs.numbers.isValid() && (!attrs.numbersExtra || attrs.numbersExtra.isValid());
    attrs.numbersExtraIsValid = attrs.numbersExtra && attrs.numbersExtra.isValid();
    attrs.numbersIsValid = attrs.numbers && attrs.numbers.isValid();
    return attrs;
  },
  updateSystemLimits() {
    const {
      numbersLimits,
      numbersExtraLimits
    } = svs.numbergames.rules.system.systemLimits({
      rules: svs.numbergames.game_model.rulesRadio.request('rules'),
      numberSize: this.get('numbers').length,
      numberExtraSize: this.has('numbersExtra') && this.get('numbersExtra').length,
      level: this.get('level')
    });
    this.get('numbers').setLengths(numbersLimits);
    if (this.has('numbersExtra')) this.get('numbersExtra').setLengths(numbersExtraLimits);
  },
  getNumberOfGeneratedRows() {
    let {
      numbersLength,
      numbersExtraLength
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    numbersLength = numbersLength || this.get('numbers').length;
    numbersExtraLength = numbersExtraLength || this.has('numbersExtra') && this.get('numbersExtra').length;
    const {
      numbersMaxLength,
      numbersExtraMaxLength
    } = rulesRadio.request('rules');
    let generatedRows = 0;
    if (this.get('numbers').isValid() && (!this.has('numbersExtra') || this.get('numbersExtra').isValid())) {
      generatedRows = svs.numbergames.rules.system.generatedRows({
        numbersLength,
        numbersExtraLength,
        numbersRowSize: this.get('level') || numbersMaxLength,
        numbersExtraRowSize: numbersExtraMaxLength
      });
    }
    return generatedRows;
  },
  levelChanged(model, level) {
    if (this.get('isSystem')) {
      this.updateSystemLimits();
    } else {
      this.get('numbers').setLengths({
        min: level,
        max: level
      });
    }
    this.setValid();
  }
});

 })(window);